<template>
  <div>
    <NuxtLayout>
      <NuxtLoadingIndicator />
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import { useMainStore } from './stores/main';
import { useUserStore } from './stores/user';

const store = useMainStore()
const userStore = useUserStore()
userStore.isMockingEnabled = false

onMounted(async () => {
  // `nuxtTick` 사용 필수!!! 사용하지 않으면 어째서인지 첫번째로 걸린 `await` 네트워크는 실제 요청이 가지 않고 `idle` 상태로 대기되버린다.
  nextTick(async () => {
    try {
      await userStore.injectUser()
    } catch (e) {
      // auto-refresh 401 등 인증 실패 시 예외가 발생해도 랜딩화면이 멈추지 않도록 처리
      console.error('injectUser 오류 (로그인 안된 상태로 계속):', e)
    }
    try {
      await userStore.init()
    } catch (e) {
      console.error('userStore.init 오류:', e)
    }
    store.isLanding = false
  })
})
</script>
